import {fsaPayloadByKeys} from './helpers'

export const ACTIVATE_AB_TEST = 'ACTIVATE_AB_TEST' // this string is also used in Optimizely tests, so don't change it
export const activateABTest = fsaPayloadByKeys(ACTIVATE_AB_TEST, ['test', 'variation'])
